import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { GestionarIncentivoBicicletaComponent } from './gestionar-incentivo-bici.component';
import { FuncionariosIncentivoBiciComponent } from './funcionarios-incentivo-bici.component';
import { AuthGuard } from 'src/app/shared/guards/authGuard/auth.guard';

const routes: Routes = [
    { path: '', component: FuncionariosIncentivoBiciComponent },
    { path: 'gestion', component: GestionarIncentivoBicicletaComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class GestionarIncentivoBicicletaRouting { }